import { useMemo } from 'react';
import { useIsMobile } from '../../../hook/useIsMobile';
import { infoStore, TicketNumberType } from '../../../store/infoStore';
import { MainEventPc } from './MainEvent/MainEvent.pc';
import { MainEventMobile } from './MainEvent/MainEvent.mobile';

export type MainEventViewProps = {
  goOfflineTab: () => void;
  ticketsToRender: TicketNumberType[];
  totalCount: number;
  usedCount: number;
  ticketUseYn: 'Y' | 'N' | undefined;
};

export const MainEvent = ({ goOfflineTab }: { goOfflineTab: () => void }) => {
  const isMobile = useIsMobile();
  const { info } = infoStore();

  const sortedOrder = useMemo(() => {
    if (!info.userTicketInfo) return null;
    return [...info.userTicketInfo]
      .sort((a, b) => {
        if (a.usedYn === 'Y' && b.usedYn !== 'Y') return 1;
        if (a.usedYn !== 'Y' && b.usedYn === 'Y') return -1;
        return 0;
      })
      .map((t) => t.ticketNo);
  }, [info.userTicketInfo?.length]);

  const ticketsToRender: TicketNumberType[] =
    sortedOrder
      ?.map((ticketNo) => info.userTicketInfo?.find((t) => t.ticketNo === ticketNo))
      .filter((t): t is TicketNumberType => !!t) ?? [];

  const totalCount = info.userTicketInfo?.length ?? 0;
  const usedCount = info.userTicketInfo?.filter((ticket) => ticket.usedYn === 'Y').length ?? 0;

  const props: MainEventViewProps = {
    goOfflineTab,
    ticketsToRender,
    totalCount,
    usedCount,
    ticketUseYn: info.ticketUseYn,
  };

  return isMobile ? <MainEventMobile {...props} /> : <MainEventPc {...props} />;
};
